import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import PostAddIcon from '@mui/icons-material/PostAdd';
import BusinessIcon from '@mui/icons-material/Business';
import MenuBookIcon from '@mui/icons-material/MenuBook';

function PurchasesNav({ currentUser, pendingApprovalsCount = 0 }) {
  const navigate = useNavigate();
  const location = useLocation();
  const perms = currentUser?.effective_permissions || {};

  const canSeeApprovals =
    perms['menu.purchase_approval'] !== false || perms['menu.purchases'] !== false;

  const active = (paths) =>
    paths.some(
      (p) =>
        location.pathname === p ||
        (p === '/purchases' &&
          location.pathname === '/purchases' &&
          !location.search.includes('view=requests')),
    );

  const isRequests =
    location.pathname === '/purchases' && location.search.includes('view=requests');

  const btnSx = (isActive) => ({
    fontWeight: isActive ? 700 : 400,
    borderBottom: isActive ? '2px solid' : '2px solid transparent',
    borderRadius: 0,
    px: 2,
    py: 1,
    minWidth: 0,
    color: isActive ? 'primary.main' : 'text.primary',
    '&:hover': { bgcolor: 'action.hover' },
  });

  return (
    <Box display="flex" gap={0.5} mb={2} borderBottom={1} borderColor="divider">
      <Button
        startIcon={<ReceiptLongIcon />}
        sx={btnSx(active(['/purchases']) && !isRequests)}
        onClick={() => navigate('/purchases')}
      >
        Закупівлі
      </Button>
      {canSeeApprovals && (
        <Button
          startIcon={<FactCheckOutlinedIcon />}
          sx={btnSx(active(['/purchase-approvals']))}
          onClick={() => navigate('/purchase-approvals')}
        >
          Погодження{pendingApprovalsCount > 0 ? ` (${pendingApprovalsCount})` : ''}
        </Button>
      )}
      <Button
        startIcon={<PostAddIcon />}
        sx={btnSx(isRequests)}
        onClick={() => navigate('/purchases?view=requests')}
      >
        Заявки
      </Button>
      <Button
        startIcon={<BusinessIcon />}
        sx={btnSx(active(['/suppliers']))}
        onClick={() => navigate('/suppliers')}
      >
        Постачальники
      </Button>
      <Button
        startIcon={<MenuBookIcon />}
        sx={btnSx(active(['/supplier-catalog']))}
        onClick={() => navigate('/supplier-catalog')}
      >
        Журнал постачальників
      </Button>
    </Box>
  );
}

export default PurchasesNav;
